import { render, staticRenderFns } from "./jiankangshi.vue?vue&type=template&id=30feb2a1&"
import script from "./jiankangshi.vue?vue&type=script&lang=ts&"
export * from "./jiankangshi.vue?vue&type=script&lang=ts&"
import style0 from "./jiankangshi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports